import { Account } from '@templates/Account';

export default Account;
